import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines } from "@/components/Motion";

export const PageHero = ({ eyebrow, lines, intro, img, alt, children, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  return (
    <section ref={ref} data-testid={testId} className="grain relative overflow-hidden bg-[#14263D] pb-16 pt-36 text-white md:pb-24 md:pt-44">
      {img && (
        <motion.div style={{ y }} className="absolute inset-0">
          <motion.img
            src={img}
            alt={alt}
            className="h-full w-full object-cover opacity-35"
            initial={{ scale: 1.15 }}
            animate={{ scale: 1 }}
            transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#14263D] via-[#14263D]/85 to-[#14263D]/40" />
        </motion.div>
      )}
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.p className="eyebrow !text-[#f0b3b7]" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>{eyebrow}</motion.p>
        <h1 className="mt-5 max-w-5xl font-display text-5xl font-semibold leading-[0.98] tracking-tight sm:text-6xl lg:text-[5.5rem]">
          <MaskLines lines={lines} delay={0.1} />
        </h1>
        {intro && (
          <motion.p
            className="mt-8 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.5 }}
          >
            {intro}
          </motion.p>
        )}
        {children && (
          <motion.div className="mt-10 flex flex-wrap gap-4" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.65 }}>
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
};
